export class AuthRoutes {
  public static ROUTES = {
    Login: {
      path: 'login',
      fullPath: 'login',
    },
    LoginMx: {
      path: 'mx/login',
      fullPath: 'mx/login',
    },
    LoginPe: {
      path: 'pe/login',
      fullPath: 'pe/login',
    },
    LoginBr: {
      path: 'br/login',
      fullPath: 'br/login',
    },
    Public: {
      path: 'public',
      fullPath: 'public',
    },
    PublicCountry: {
      path: ':country',
      fullPath: ':country',
    },
    PublicHome: {
      path: 'home',
      fullPath: ':country/home',
    },
    Emission: {
      path: 'emission',
      fullPath: ':country/emission',
    },
    EmissionId: {
      path: '',
      fullPath: ':country/emission/:policyId',
    },
    PolicyCheck: {
      path: 'policy-documents',
      fullPath: ':country/policy-documents',
    },
    PolicyNumber: {
      path: ':policyNumber',
      fullPath: ':country/policy-documents/:policyNumber',
    },
    ValidationLine: {
      path: ':validationLine',
      fullPath: ':country/policy-documents/:policyNumber/:validationLine',
    },
  };
}
